<template>
<v-app>
    <div class="page_thankyouuser">

        <v-container>
            <v-row class="justify-center">
                <v-col cols="11" sm="10" md="11" lg="5" xl="6">
                    <div class="img_thankyouuser">
                        <img :src="beforeImage">
                    </div>
                    <div class="text-center title_thankyouuser">ขอบคุณลูกค้าทุกท่าน</div>
                    <div class="text-center title_thankyouuser">ที่ให้เราเป็นส่วนหนึ่งของมื้ออาหารแสนอร่อย</div>
                </v-col>
            </v-row>
        </v-container>

    </div>
</v-app>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/new_logologinandtkfull.png";
export default {
    name: 'thankYouUser',
        data() {
        return {
            beforeImage: before_image,
            bg_color: 'linear-gradient(to top, #038cc1 , #55c0e9)',
        }
    },
    methods: {
        async colorRestaurant() {
            HTTP.get(`/showColor?store_id=${this.$route.query.store_id}&token=`+this.$route.params.token)
                .then((response) => {
                    if (response.data.successful === true) {
                        this.bg_color = response.data.color_code
                        this.beforeImage = response.data.logo_image
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        // this.$router.push('/nametakeoutuser')
                    }

                })
        },
    },
    created(){
        this.$store.commit('clearCartListUser')
        this.$store.commit('clearCartTakeOutTableListUser')
        this.$store.commit('clearCartListUserTakeOut')
        this.$store.commit('clearCartOrderOnlineUser')
    },
    mounted() {
        this.colorRestaurant()
    },
}
</script>

<style scoped>
.page_thankyouuser {
    /* background-color: #fdbd10; */
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.img_thankyouuser {
    width: 300px;
    margin: auto;
}

.img_thankyouuser>img {
    max-width: 100%;
}

.title_thankyouuser {
    font-size: 22px;
    /* color: #fff; */
}
</style>
